const common = {
    //存到本地localStorage
    setCache(key,value){
        window.localStorage.setItem('institution-'+key, value);
    },
    //取本地localStorage
    getCache(key){
        return window.localStorage.getItem('institution-'+key);   
    },
    //移除本地localStorage的数据
    removeCache(key){
        window.localStorage.removeItem('institution-'+key)
    },
    // 取逗号前面的值
    getValue(text) {
        console.log('-----:::',text)
        if(!text ||  text=="undefined" || text == null || typeof(text) == "undefined") {
            console.log('-----:::null',text)
            return text
        }
        if(typeof(text) == 'object') {
            console.log('-----:::object',text)
            return text[0]
          }
        if(text.search(',')!=-1) {
            console.log('-----:::,',text)
            return text.split(',')[0]
        }else {
            console.log('-----:::text',text)
            return text
        }
    },
    // 手机正则
    checkPhone(phone) {
        return /^1[3456789]\d{9}$/.test(phone);
    },
}
//导出
export {common}